import React from 'react'
import AfternoonIcon from '../../../../../../Assets/Images/icons/newIcons/afternoonIcon'
import MorningIcon from '../../../../../../Assets/Images/icons/newIcons/morningIcon'
import LunchIcon from '../../../../../../Assets/Images/icons/newIcons/lunchIcon'
import { LOCATION_EVENT_TYPES } from '../../../../../../shared/constants'

export const eventTypeOptions = [
  {
    label: 'Festival / Fair',
    value: LOCATION_EVENT_TYPES.FESTIVAL_FAIR,
  },
  {
    label: 'Concert / Music Event',
    value: LOCATION_EVENT_TYPES.CONCERT_MUSIC_EVENT,
  },
  {
    label: 'Sports Event',
    value: LOCATION_EVENT_TYPES.SPORTS_EVENT,
  },
  {
    label: 'Religious Gathering',
    value: LOCATION_EVENT_TYPES.RELIGIOUS_GATHERING,
  },
  {
    label: 'Trade Show / Expo',
    value: LOCATION_EVENT_TYPES.TRADE_SHOW_EXPO,
  },
  {
    label: 'Conference / Seminar',
    value: LOCATION_EVENT_TYPES.CONFERENCE_SEMINAR,
  },
  {
    label: 'Networking Event',
    value: LOCATION_EVENT_TYPES.NETWORKING_EVENT,
  },
  {
    label: 'Job / Career Fair',
    value: LOCATION_EVENT_TYPES.JOB_CAREER_FAIR,
  },
  {
    label: 'Wedding',
    value: LOCATION_EVENT_TYPES.WEDDING,
  },
  {
    label: 'Party (Birthday, Graduation, etc.)',
    value: LOCATION_EVENT_TYPES.PARTY,
  },
  {
    label: 'School / College Event',
    value: LOCATION_EVENT_TYPES.SCHOOL_COLLEGE_EVENT,
  },
  {
    label: 'Community Gathering',
    value: LOCATION_EVENT_TYPES.COMMUNITY_GATHERING,
  },
  {
    label: 'Political / Public Rally',
    value: LOCATION_EVENT_TYPES.POLITICAL_PUBLIC_RALLY,
  },
  {
    label: 'Other',
    value: LOCATION_EVENT_TYPES.OTHER,
  },
]

export const MODAL_STEPS = {
  BASE_INFORMATION: 1,
  SCHEDULE: 2,
}

export const WEEK_DAYS = [
  { label: 'Mon', value: 'monday' },
  { label: 'Tue', value: 'tuesday' },
  { label: 'Wed', value: 'wednesday' },
  { label: 'Thu', value: 'thursday' },
  { label: 'Fri', value: 'friday' },
  { label: 'Sat', value: 'saturday' },
  { label: 'Sun', value: 'sunday' },
]

export const TIME_SLOTS = [
  { label: 'Morning', value: 'morning', icon: <MorningIcon /> },
  { label: 'Lunch', value: 'lunch', icon: <LunchIcon /> },
  { label: 'Afternoon', value: 'afternoon', icon: <AfternoonIcon /> },
]
